import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import ejecutivo from './data/ejecutivo';
import consejero from './data/consejero';
import conferenciante from './data/conferenciante';
import Navbar from './components/layout/Navbar';
import Hero from './components/sections/Hero';
import Talks from './components/sections/Talks';
import About from './components/sections/About';
import BoardSection from './components/sections/BoardSection';
import Experience from './components/sections/Experience';
import Competencies from './components/sections/Competencies';
import Education from './components/sections/Education';
import Contact from './components/sections/Contact';
import { useVisitTracker } from './hooks/useVisitTracker';
import './index.css';

const CVContent: React.FC = () => {
  const { mode } = useApp();
  useVisitTracker(mode);
  const data = { ejecutivo, consejero, conferenciante }[mode];

  return (
    <>
      <Navbar />
      <Hero data={data} />
      {data.talks && data.talks.length > 0 && <Talks talks={data.talks} />}
      <About profileStatement={data.profileStatement} />
      {mode === 'consejero' && data.boardMemberships.length > 0 && (
        <BoardSection boardMemberships={data.boardMemberships} />
      )}
      <Experience experience={data.experience} />
      <Competencies competencies={data.competencies} techStack={data.techStack} />
      <Education education={data.education} />
      <Contact contactCTA={data.contactCTA} />
    </>
  );
};

function App() {
  return (
    <AppProvider>
      <CVContent />
    </AppProvider>
  );
}

export default App;
